{
  "accordion": {
    "breakfast": "Breakfast",
    "cleanup": "Cleanup",
    "lunch": "Lunch",
    "pickKidsFromSchool": "Pick kids from school",
    "takeKidsToSchool": "Take kids to school",
    "todaysTasks": "Today's tasks"
  },
  "account": {
    "staffRole": "You can change your staff role for QA purposes here.\nChanges will only affect the current tab and will not be saved to the database."
  },
  "alert": {
    "actionCta": "Undo",
    "actionTitle": "The selected emails have been marked as spam.",
    "errorDescription": "Please verify your billing information and try again.<ul><li>Check your card details</li><li>Verify billing address</li></ul>",
    "errorTitle": "Unable to process your payment.",
    "extendedDescription": "This is an equally long description that contains detailed information about the alert. It shows how the component can accommodate extensive content while preserving proper spacing, alignment, and readability across different screen sizes and viewport widths. This helps ensure the user experience remains consistent regardless of the content length.",
    "extendedTitle": "This is an extremely long alert title that spans multiple lines to demonstrate how the component handles very lengthy headings while maintaining readability and proper text wrapping behavior",
    "successDescription": "This is an alert with icon, title and description.",
    "successTitle": "Success! Your changes have been saved"
  },
  "alertDialog": {
    "description": "This action cannot be undone. This will permanently delete your account and remove your data from our servers.",
    "title": "Are you absolutely sure?",
    "trigger": "Show dialog"
  },
  "badge": {
    "default": "Default",
    "destructive": "Destructive",
    "outline": "Outline",
    "secondary": "Secondary"
  },
  "blocks": {
    "title": "Blocks"
  },
  "button": {
    "default": "Default",
    "destructive": "Destructive",
    "disabled": "Disabled",
    "ghost": "Ghost",
    "large": "Large",
    "learnMore": "Learn more",
    "link": "Link",
    "loading": "Loading...",
    "outline": "Outline",
    "secondary": "Secondary",
    "send": "Send",
    "small": "Small"
  },
  "card": {
    "image": {
      "description": "This is a card with an image.",
      "title": "Image card"
    },
    "login": {
      "cta": "Login",
      "ctaGoogle": "Login with Google",
      "description": "Enter your email below to login to your account",
      "emailLabel": "Email",
      "emailPlaceholder": "me@example.com",
      "forgotPassword": "Forgot your password?",
      "noAccount": "Don't have an account? <a>Sign up</a>",
      "passwordLabel": "Password",
      "title": "Login to your account"
    },
    "meetingNotes": {
      "description": "Transcript from the meeting with the client.",
      "title": "Meeting notes"
    },
    "meta": {
      "content": "Content",
      "contentOnly": "Content only",
      "footer": "Footer",
      "footerOnly": "Footer only",
      "headerAndContentDescription": "This is a card with a header and content.",
      "headerAndContentTitle": "Header and content",
      "headerAndFooterDescription": "This is a card with a header and a footer.",
      "headerAndFooterTitle": "Header and footer",
      "headerContentAndFooterDescription": "This is a card with a header, content and a footer.",
      "headerContentAndFooterTitle": "Header, content, and footer",
      "headerOnlyDescription": "This is a card with a header and a description.",
      "headerOnlyTitle": "Header only"
    }
  },
  "checkbox": {
    "multi": {
      "description": "Select how you would like to receive notifications",
      "email": "Email",
      "label": "Notification preferences",
      "push": "Push notifications",
      "sms": "SMS"
    },
    "privacy": "I accept the privacy policy",
    "terms": "I accept the terms and conditions"
  },
  "components": {
    "errorMessage": "Something went wrong in component: {{name}}",
    "title": "Components"
  },
  "datePicker": {
    "placeholder": "Select a date",
    "requiredDate": "Must select a date"
  },
  "dialog": {
    "form": {
      "description": "Make changes to your profile here. Click save when you're done.",
      "nameLabel": "Name",
      "title": "Edit your profile",
      "trigger": "Edit profile",
      "usernameLabel": "Username"
    },
    "scrollableContent": {
      "description": "This is a dialog with scrollable content.",
      "title": "Scrollable content",
      "trigger": "Scrollable content"
    },
    "stickyFooter": {
      "description": "This is a dialog with scrollable content and a sticky footer.",
      "title": "Sticky footer",
      "trigger": "Sticky footer"
    }
  },
  "dropdownMenu": {
    "account": "Account",
    "billing": "Billing",
    "notifications": "Notifications",
    "upgrade": "Upgrade to Pro"
  },
  "form": {
    "bioDescription": "You can @mention other users and organizations.",
    "bioLabel": "Bio",
    "bioPlaceholder": "Tell us about yourself",
    "emailDescription": "This is the email address that will be displayed on your profile.",
    "emailLabel": "Display email",
    "emailPlaceholder": "Select an email",
    "nextSubscriptionDateLabel": "Next subscription date",
    "nextSubscriptionDatePlaceholder": "Select a date",
    "notificationsChannelLabel": "Channel preferences",
    "notificationsSubtitle": "Notifications",
    "notificationsTypeLabel": "Notifiy me about...",
    "usernameDescription": "This is your public display name.",
    "usernameLabel": "Username",
    "usernamePlaceholder": "Enter your username",
    "validation": {
      "bioTooLong": "Bio must be at most 140 characters long",
      "bioTooShort": "Bio must be at least 10 characters long",
      "usernameTooShort": "Username must be at least 3 characters long"
    }
  },
  "goToSandbox": "Go to the sandbox",
  "input": {
    "default": "Default",
    "disabled": "Disabled",
    "error": "With error",
    "file": "File",
    "number": "Number",
    "password": "Password",
    "phoneNumber": "Phone number",
    "required": "Required",
    "requiredLabel": "You must select this",
    "search": "Search"
  },
  "inputOtp": {
    "withCharacters": "With characters",
    "withDigits": "With digits",
    "withDigitsAndCharacters": "With digits and characters"
  },
  "label": {
    "disabled": "Disabled",
    "username": "Username"
  },
  "navigationMenu": {
    "backlog": "Backlog",
    "blocks": "Blocks",
    "blog": "Blog",
    "blogDescription": "Read our latest blog posts.",
    "components": "Components",
    "componentsDescription": "Browse all components in the library.",
    "documentation": "Documentation",
    "documentationDescription": "Learn how to use the library.",
    "done": "Done",
    "list": "List",
    "simpleList": "Simple List",
    "toDo": "To Do",
    "withIcons": "With Icons"
  },
  "orgName": "Mindsea Development",
  "radioGroup": {
    "cardLabel": "Card",
    "comfortable": "Comfortable",
    "compact": "Compact",
    "default": "Default",
    "disabledLabel": "Spacing (Disabled)",
    "planDescription": "Select a plan that works best for your team.",
    "planLabel": "Plan",
    "proDescription": "Advanced features larger teams looking to scale their business.",
    "proLabel": "Pro Plan",
    "spacingLabel": "Spacing",
    "starterDescription": "Perfect for small teams getting started with our platform.",
    "starterLabel": "Starter Plan"
  },
  "scrollArea": {
    "photoBy": "Photo by <bold>{{artist}}</bold>",
    "tags": "Tags"
  },
  "select": {
    "asyncMultiSelectLabel": "Multi select (async)",
    "asyncMultiSelectPlaceholder": "Select your favourite Pokemons",
    "asyncSingleSelectLabel": "Single select (async)",
    "asyncSingleSelectPlaceholder": "Select your favourite Pokemon",
    "disabled": "Disabled",
    "multiSelectLabel": "Multi select",
    "multiSelectPlaceholder": "Select colors",
    "singleSelectLabel": "Single select",
    "singleSelectPlaceholder": "Select a color"
  },
  "separator": {
    "blog": "Blog",
    "description": "Vertical & horizontal seperators.",
    "docs": "Docs",
    "source": "Source",
    "title": "Separators"
  },
  "sheet": {
    "editProfile": {
      "description": "Make changes to your profile here. Click save when you're done.",
      "nameLabel": "Name",
      "title": "Edit profile",
      "usernameLabel": "Username"
    }
  },
  "switch": {
    "airplaneMode": "Airplane mode",
    "bluetooth": "Bluetooth",
    "disabled": "Disabled switch",
    "required": "Required switch"
  },
  "table": {
    "caption": "A list of your recent invoices",
    "header": {
      "amount": "Amount",
      "invoice": "Invoice",
      "method": "Method",
      "status": "Status"
    },
    "total": "Total"
  },
  "tabs": {
    "account": "Account",
    "accountDescription": "Make changes to your account here. Click save when you're done.",
    "code": "Code",
    "currentPasswordLabel": "Current password",
    "disabled": "Disabled",
    "home": "Home",
    "nameLabel": "Name",
    "newPasswordLabel": "New password",
    "password": "Password",
    "passwordDescription": "Change your password here. After saving, you'll be logged out.",
    "preview": "Preview",
    "savePasswordCta": "Save password",
    "settings": "Settings",
    "usernameLabel": "Username"
  },
  "text": {
    "blurb": "The quick brown fox jumps over the lazy dog."
  },
  "textarea": {
    "default": "Default",
    "disabled": "Disabled",
    "error": "With error",
    "required": "Required text area",
    "requiredLabel": "You must select this"
  },
  "theme": {
    "title": "Theme"
  },
  "toast": {
    "default": "Event has been created",
    "description": "Monday, January 3rd at 6:00pm",
    "error": "Event could not be created",
    "info": "Be at the area 10 minutes before the event time",
    "warning": "Event start time cannot be earlier than 8am"
  },
  "tooltip": {
    "content": "Add to library",
    "default": "Hover",
    "extendedContent": "To learn more about how this works, check out the docs.\n\nIf you have any questions, please reach out to us.",
    "info": "Info"
  }
}
